import React from 'react';

const KeyFeatures = () => {
  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Key Features</h2>
      <p className="text-gray-700 leading-relaxed mb-8">
        ASI1 is a cutting-edge language model designed to think, reason, and act autonomously in complex environments. Inspired by agentic AI principles, ASI1 provides highly adaptive, goal-driven, and context-aware responses, making it an ideal tool for developers, researchers, and enterprises looking to integrate next-generation AI capabilities.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h3 className="text-lg font-semibold text-blue-700 mb-3">Agentic Reasoning</h3>
          <p className="text-gray-700">
            ASI1 can autonomously plan, execute, and adapt its approach based on evolving inputs and goals.
          </p>
        </div>

        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h3 className="text-lg font-semibold text-blue-700 mb-3">Natural Language Understanding</h3>
          <p className="text-gray-700">
            ASI1 is highly proficient in understanding and generating human-like text across multiple domains.
          </p>
        </div>

        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h3 className="text-lg font-semibold text-blue-700 mb-3">Multi-Step Task Execution</h3>
          <p className="text-gray-700">
            Unlike traditional LLMs, ASI1 can handle multistep, goal-oriented tasks without constant user intervention.
          </p>
        </div>

        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h3 className="text-lg font-semibold text-blue-700 mb-3">Contextual Memory</h3>
          <p className="text-gray-700">
            Retains and utilizes contextual memory for longer, more coherent interactions.
          </p>
        </div>

        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h3 className="text-lg font-semibold text-blue-700 mb-3">API-Driven Integration</h3>
          <p className="text-gray-700">
            Easily integrate ASI1 into your applications with a powerful API.
          </p>
        </div>

        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h3 className="text-lg font-semibold text-blue-700 mb-3">Web3 Native</h3>
          <p className="text-gray-700">
            Built from the ground up for decentralized environments and blockchain interactions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;
